import Backdraft from "backdraft-app/src/backdraft";

import "graveyard/build_profiles/invoca_app";
import "graveyard/build_profiles/management_app";

import "sparks/invoca_app";
import "sparks/modal_dialog";
import "sparks/form";

import "./src/app";

import "./src/models/expression_owner";

import "./src/models/voice_keyword";

import "./src/models/expression_terminals/meta_data";
import "./src/models/expression_terminals/base";
import "./src/models/expression_terminals/string_compare";
import "./src/models/expression_terminals/number_compare";

import "./src/models/expression_terminals/adwords_data";
import "./src/models/expression_terminals/age";
import "./src/models/expression_terminals/boolean";
import "./src/models/expression_terminals/conjunction";
import "./src/models/expression_terminals/custom_data";
import "./src/models/expression_terminals/scorecard";
import "./src/models/expression_terminals/duration";
import "./src/models/expression_terminals/keypress";
import "./src/models/expression_terminals/money_compare";
import "./src/models/expression_terminals/not";
import "./src/models/expression_terminals/paren";
import "./src/models/expression_terminals/phone_type";
import "./src/models/expression_terminals/pool_param";
import "./src/models/expression_terminals/string_list";
import "./src/models/expression_terminals/unsupported";
import "./src/models/expression_terminals/voice";

import "./src/collections/expression_terminals";
import "./src/collections/keywords";

import "./src/views/voice_form/form";
import "./src/views/voice_form/modal";

import "./src/views/CollectionSyncMixin";
import "./src/views/ExpressionAutoComplete";
import "./src/views/ExpressionCanvas";
import "./src/views/Sidebar";
import "./src/views/StyleSheet";
import "./src/views/terminals/AdwordsData";
import "./src/views/terminals/Age";
import "./src/views/terminals/BaseMixin";
import "./src/views/terminals/BooleanTerminal";
import "./src/views/terminals/Conjunction";
import "./src/views/terminals/CustomData";
import "./src/views/terminals/Scorecard";
import "./src/views/terminals/Duration";
import "./src/views/terminals/Keypress";
import "./src/views/terminals/MetaData";
import "./src/views/terminals/MoneyCompare";
import "./src/views/terminals/Not";
import "./src/views/terminals/NumberCompare";
import "./src/views/terminals/NumberCompareTerminalMixin";
import "./src/views/terminals/Paren";
import "./src/views/terminals/PhoneType";
import "./src/views/terminals/PoolParam";
import "./src/views/terminals/StringCompare";
import "./src/views/terminals/StringCompareTerminalMixin";
import "./src/views/terminals/StringListTerminal";
import "./src/views/terminals/TerminalNameNode";
import "./src/views/terminals/Unsupported";
import "./src/views/terminals/Voice";
import "./src/views/TerminalSearch";
import "./src/views/ToggleMode";

export default Backdraft.app("Shared/ExpressionBuilder");
